module.exports = __webpack_public_path__ + "static/media/fx.64ac50b2.jpg";